__turbopack_context__.v({
  "container": "Spinner-module__eq-RVq__container",
  "tekst": "Spinner-module__eq-RVq__tekst",
});
